import { VueConstructor } from "vue";
import {
	EmployeeDetailsValueRepresentation,
	InstitutionDetailsValueRepresentation
} from "@/lib/apis/replicable/models";

import { filter as filterReadable } from "./ReadableFilter";
import { filter as filterNumber } from "./NumberFilter";

function filter(detailsValue?: DetailsValue | null): string {
	if (!detailsValue) {
		return "";
	}

	let valueReadable = detailsValue.value;

	if (detailsValue.valueLabel) {
		valueReadable = detailsValue.valueLabel;
	}

	if (detailsValue.type === "NUMERIC" || detailsValue.type === "PERCENTAGE") {
		if (detailsValue.value) {
			valueReadable = filterNumber(parseFloat(detailsValue.value));

			if (detailsValue.type === "PERCENTAGE") {
				valueReadable += "%";
			}
		}
	} else if (detailsValue.type === "BOOLEAN" && detailsValue.value != undefined) {
		valueReadable = filterReadable(parseInt(detailsValue.value, 10) === 1, "boolean");
	} else if (detailsValue.type === "DATE") {
		valueReadable = filterReadable(detailsValue.value, "date");
	} else if (!valueReadable || valueReadable.length === 0) {
		valueReadable = "-";
	} else {
		if (valueReadable.search("=") !== -1) {
			valueReadable = valueReadable
				.split(";")
				.map(part => {
					const keyValue = part.split("=");
					return `${keyValue[0][0].toUpperCase()}${keyValue[0].slice(1)}: ${keyValue[1] || ""}`;
				})
				.join(", ");
		}
	}

	return valueReadable ?? "";
}

export default {
	install(Vue: VueConstructor) {
		Vue.filter("readableDetailsValue", filter);
	}
};

export { filter };

type DetailsValue = EmployeeDetailsValueRepresentation | InstitutionDetailsValueRepresentation;
